import { AuditEventType, AuditTrailFilters } from '../../../../../backend/src/auditTrail/auditTrail.types';
import {
  FilterField,
  ServerSideFilterPopover as GenericServerSideFilterPopover,
} from '@/new/components/server-side-filter-popover';

interface AuditTrailFilterPopoverProps {
  filters: AuditTrailFilters;
  onFiltersChange: (filters: AuditTrailFilters) => void;
  clearAllFilters: () => void;
}

const filterFields: FilterField[] = [
  {
    type: 'select',
    key: 'auditEventType',
    label: 'Audit Event',
    placeholder: 'Select event type...',
    options: [
      { value: AuditEventType.CreatedMatter, label: 'Created Matter' },
      { value: AuditEventType.UpdatedMatter, label: 'Updated Matter' },
      { value: AuditEventType.DeletedMatter, label: 'Deleted Matter' },
      { value: AuditEventType.AddedUserMatter, label: 'Added User to Matter' },
      { value: AuditEventType.RemovedUserMatter, label: 'Removed User from Matter' },
      { value: AuditEventType.CreatedSubset, label: 'Created Subset' },
      { value: AuditEventType.UpdatedSubset, label: 'Updated Subset' },
      { value: AuditEventType.DeletedSubset, label: 'Deleted Subset' },
    ],
  },
  {
    type: 'dateRange',
    startKey: 'startDate',
    endKey: 'endDate',
    label: 'Event Date Range',
  },
];

export function AuditTrailFilterPopover({ filters, onFiltersChange, clearAllFilters }: AuditTrailFilterPopoverProps) {
  return (
    <GenericServerSideFilterPopover
      filters={filters}
      onFiltersChange={onFiltersChange}
      clearAllFilters={clearAllFilters}
      fields={filterFields}
    />
  );
}
